// eslint-disable-next-line import/namespace,import/named
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import 'leaflet-defaulticon-compatibility';

type Props = {
  title: string;
  lat: number;
  lng: number;
  zoom: number;
  width: string;
  height: string;
};

function ClientMap({ lat, lng, title, zoom, width, height }: Props) {
  return (
    <MapContainer
      center={{ lng: lat, lat: lng }}
      zoom={zoom}
      scrollWheelZoom={false}
      style={{ height, width, position: 'relative', zIndex: 1 }}
    >
      <TileLayer
        // @ts-ignore
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <Marker
        position={{ lng: lat, lat: lng }}
        // @ts-ignore
        draggable={false}
      >
        <Popup>{title}</Popup>
      </Marker>
    </MapContainer>
  );
}

export default ClientMap;
